import { Op, Query } from 'contensis-delivery-api'
import { cleanTerms, standard } from '~/content-types/~queries/search/lib/misc'
import { getClient, initClientWithFetch } from '~/lib/contensis/client'
import { isDevelopment } from '~/utils/misc'

// Use a custom fetch function
// const customFetch: typeof fetch = async (input, init) => {
//   const response = await fetch(input, init)
//   return response
// }

// This is how you would init the client with a custom fetch function
// initClientWithFetch(customFetch)

// Init the client with the custom fetch function
initClientWithFetch()

export const TestNavSearch = async (
  value: string,
  type: string,
  pageSize: number = 5
) => {
  const client = getClient()

  const trimmed = value.trim()
  if (!trimmed) return null

  const terms = cleanTerms(trimmed)

  const query = new Query(
    Op.equalTo('sys.versionStatus', isDevelopment ? 'latest' : 'published'),
    Op.equalTo('sys.dataFormat', 'entry'),
    Op.equalTo('seoStandard.search', true),
    standard(trimmed, terms)
  )

  query.pageSize = pageSize
  query.fields = [
    'sys.uri',
    'entryTitle',
    'description',
    'seoStandard.title',
    'seoStandard.description',
    'seoStandard.keywords',
    'seoStandard.search',
    'seoStandard.focusKeyphrase'
  ]

  if (type === 'courses') {
    query.where.add(
      Op.and(
        Op.or(
          Op.equalTo('sys.contentTypeId', 'studyUndergraduateCoursePage'),
          Op.equalTo('sys.contentTypeId', 'pageCoursePGT'),
          Op.equalTo('sys.contentTypeId', 'pageCoursePGR'),
          Op.equalTo('sys.contentTypeId', 'pageCourseCPD')
        )
      )
    )
  }

  if (type === 'research') {
    query.where.add(
      Op.and(
        Op.or(
          Op.equalTo('sys.contentTypeId', 'pageCaseStudyResearch'),
          Op.equalTo('sys.contentTypeId', 'pageCentreAdvanceResearch'),
          Op.equalTo('sys.contentTypeId', 'pageCentreBasicResearch'),
          Op.equalTo('sys.contentTypeId', 'pageStandardResearch')
        )
      )
    )
  }

  if (type === 'people') {
    query.where.add(
      Op.and(Op.or(Op.equalTo('sys.contentTypeId', 'staffProfile')))
    )
  }

  try {
    const result = await client.entries.search(query, 1)

    if (!result || !result.items) {
      console.error('No items found in the response')
      return []
    }

    return result.items
  } catch (err) {
    console.error('Error during search:', err)
    return []
  }
}
